import React from 'react';
import styled from 'styled-components';

import { Box, Typography } from '@material-ui/core';

import DraftsList from '../../components/DraftsList/DraftsList';

interface Props {
  draftsObjects: any[];
  handleDeleteDraftObject: (id: string) => void;
  hidden: boolean;
}

const Drafts = (props: Props) => {
  return (
    <Box hidden={props.hidden}>
      <CaptionWrap>
        <StyledTypography fontSize="1.1rem">Under arbeid</StyledTypography>
      </CaptionWrap>
      <DraftsList draftsObjects={props.draftsObjects} handleDeleteDraftObject={props.handleDeleteDraftObject} />
    </Box>
  );
};
const CaptionWrap = styled(Box)`
  padding: 28px 0 16px;
  @media (max-width: 705px) {
    padding: 28px 18px 16px;
  }
  @media (max-width: 767px) {
    padding: 28px 26px 16px;
  }
  @media (max-width: 542px) {
    padding: 28px 18px 16px;
  }
`;
const StyledTypography = styled(({ color, fontSize, ...props }) => <Typography {...props} />)`
  color: ${props => props.color || 'default'};
  &.MuiTypography-root {
    font-size: ${props => props.fontSize};
  }
`;
export default Drafts;
